import { style } from '@vanilla-extract/css';

import { blockquoteFigure } from '../blockquoteFigure/BlockquoteFigure.css';
import { quote, quoteContent } from '../blockquoteFigure/Quote.css';
import { column } from '../columns/Column.css';
import { documentContainer } from '../document/Document.css';
import { listItem } from '../listItem/ListItem.css';
import { section } from '../section/Section.css';
import { tableCell } from '../table/TableCell.css';
import { tableHeader } from '../table/TableHeader.css';

export const paragraphContainer = style({
  selectors: {
    [`${documentContainer} > &, ${section} > &, ${column} > &`]: {
      paddingLeft: 'var(--wt-padding, 10px)',
      paddingRight: 'var(--wt-padding, 10px)',
      paddingTop: 'var(--wt-paragraph-padding-top, 12px)',
      paddingBottom: 'var(--wt-paragraph-padding-bottom, 12px)',
    },
    [`${listItem} > &`]: {
      padding: '0px',
    },
    [`${blockquoteFigure['1']} ${quote} > ${quoteContent} > &`]: {
      padding: '0px',
    },
    [`${blockquoteFigure['2']} ${quote} > ${quoteContent} > &`]: {
      padding: '0px',
    },
    [`${blockquoteFigure['3']} ${quote} > ${quoteContent} > &`]: {
      padding: '0px',
    },
    [`${tableHeader} > &`]: {
      padding: 0,
    },
    [`${tableCell} > &`]: {
      padding: 0,
    },
  },
  padding:
    'var(--wt-paragraph-padding-top, 12px) var(--wt-padding, 10px) var(--wt-paragraph-padding-bottom, 12px) var(--wt-padding, 10px)',
  fontSize: 'var(--wt-paragraph-font-size, 16px)',
  fontFamily: 'var(--wt-paragraph-font-family, Arial)',
  color:
    'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-paragraph-color, #000000)))',
  lineHeight: 'var(--wt-paragraph-line-height-size, 1.5)',
  fontWeight: 'var(--wt-paragraph-font-weight, 400)',
});

export const paragraph = style({
  textAlign: 'var(--text-align, left)',
  selectors: {
    [`${blockquoteFigure['1']} ${quote} > ${quoteContent} > ${paragraphContainer} > &`]: {
      textAlign: 'var(--text-align, var(--wt-quote-alignment, left))',
      fontFamily: 'var(--wt-quote-font-family, Arial)',
      lineHeight: 'var(--wt-quote-line-height-exact, var(--wt-quote-line-height-size-original, 1.5))',
      fontSize: 'var(--wt-quote-font-size, 16px)',
      color: 'var(--wt-quote-font-color, #000000)',
      margin: 0,
      paddingTop: 'var(--wt-paragraph-padding-top, 12px)',
      paddingBottom: 'var(--wt-paragraph-padding-bottom, 12px)',
      fontWeight: 'var(--wt-quote-font-weight, 400)',
    },
    [`${blockquoteFigure['2']} ${quote} > ${quoteContent} > ${paragraphContainer} > &`]: {
      textAlign: 'var(--text-align, var(--wt-quote-2-alignment, left))',
      fontFamily: 'var(--wt-quote-2-font-family, Arial)',
      lineHeight: 'var(--wt-quote-2-line-height-exact, var(--wt-quote-2-line-height-size-original, 1.5))',
      fontSize: 'var(--wt-quote-2-font-size, 16px)',
      color: 'var(--wt-quote-2-font-color, #000000)',
      margin: 0,
      paddingTop: 'var(--wt-paragraph-padding-top, 12px)',
      paddingBottom: 'var(--wt-paragraph-padding-bottom, 12px)',
      fontWeight: 'var(--wt-quote-2-font-weight, 400)',
    },
    [`${blockquoteFigure['3']} ${quote} > ${quoteContent} > ${paragraphContainer} > &`]: {
      textAlign: 'var(--text-align, var(--wt-quote-3-alignment, center))',
      fontFamily: 'var(--wt-quote-3-font-family, Arial)',
      lineHeight: 'var(--wt-quote-3-line-height-exact, var(--wt-quote-3-line-height-size-original, 1.5))',
      fontSize: 'var(--wt-quote-3-font-size, 16px)',
      color: 'var(--wt-quote-3-font-color, #000000)',
      margin: 0,
      paddingTop: 'var(--wt-paragraph-padding-top, 12px)',
      paddingBottom: 'var(--wt-paragraph-padding-bottom, 12px)',
      fontWeight: 'var(--wt-quote-3-font-weight, 400)',
    },
    [`${tableHeader} > ${paragraphContainer} > &`]: {
      color: 'var(--wt-table-header-font-color, #000000)',
      fontFamily: 'var(--wt-table-header-font-family)',
    },
    [`${tableCell} > ${paragraphContainer} > &`]: {
      color: 'var(--wt-table-cell-font-color, #000000)',
      fontFamily: 'var(--wt-table-cell-font-family)',
    },
    [`${listItem} > ${paragraphContainer} > &, ${listItem} > &`]: {
      fontFamily: 'var(--wt-list-font-family)',
      fontSize: 'var(--wt-list-font-size)',
      fontWeight: 'var(--wt-list-font-weight)',
      lineHeight: 'var(--wt-list-line-height-size)',
    },
  },
});
